export const GET_COUPONS = "GET_COUPONS";
export const UPDATE_COUPONS = "UPDATE_COUPONS";
export const DELETE_COUPON = "DELETE_COUPON";
export const EDIT_COUPON = "EDIT_COUPON";
